








































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import FormLayout from './FormLayout.vue';
import DataList from '../../list/DataList.vue';
import DataItem from '../../list/DataItem.vue';

import StepInputTime from '@/components/calendar/StepInputTime.vue';
import StepInputDuration from '@/components/calendar/StepInputDuration.vue';
import BaseAutocomplete from '@/components/select/BaseAutocomplete.vue';
import BaseSelect from '@/components/select/BaseSelect.vue';
import BaseButton from '@/components/buttons/BaseButton.vue';
import IconPlus from '@/components/icons/Plus.vue';
import SelectCustom from '@/components/select/SelectCustom.vue';
import DoctorEntityModule from "@/store/doctors/entity";

import CalendarModule from '@/store/calendar';

import ResponseHandlerModule from '@/store/modules/responseHandler';

import {
    getTimeInMinutes,
    getMinutesDifference,
    formatMinutesToTime,
    convertMinutes,
    setTimeWithinDay,
} from '@/utils/date'


import { FreeSlot } from '../types';
import { SelectItem } from '@/components/select/types';
import { CalendarConsultation } from '@/types/models/calendar';
import { getConsultationCalculated } from '@/api/consultations';
import { getById, getList } from '@/api/crud';
import { Maybe } from '@/types/common';
import { getDictionaries } from '@/api/dictionaries';

interface InitialCalendarConsultation {
    duration: CalendarConsultation['duration'],
    patient: Maybe<CalendarConsultation['patient']>,
    medicalService: Maybe<SelectItem>,
    clinic: Maybe<CalendarConsultation['clinic']>,
    specialization: Maybe<SelectItem>,
}

interface DoctorSpecialization {
    id: number,
    title: string,
    isCommonPractice: boolean,
    type: {
        label: string,
        slug: string,
    },
}

interface MedicalServiceTypeItem {
    id: number,
    cancellationAllowed: string,
    description: string,
    duration: number,
    isRegularConsultation: boolean,
    isRegularConsultationLabel: string,
    title: string,
    _actions: [],
}
type CalendarConsultationErrors = Partial<Record<keyof InitialCalendarConsultation, string>>;
type SelectItemType = SelectItem<number>;

const doctorMedicalServicesMapper = (service: MedicalServiceTypeItem): SelectItemType => ({ id: service.id, value: service.title });

@Component({
    components: {
        FormLayout,
        DataList,
        DataItem,
        BaseAutocomplete,
        BaseSelect,
        StepInputTime,
        StepInputDuration,
        BaseButton,
        IconPlus,
        SelectCustom,
    },
})
export default class FormConsultation extends Vue {
    @Prop({ required: true }) event!: FreeSlot
    @Prop({ default: () => [] }) clinic!: SelectItem
    
    @Watch('consultation', { deep: true })
    onConsultationChange(value: InitialCalendarConsultation) {
        if (!this.doctorId) {
            return;
        }

        if (!value.patient) {
            return;
        }

        if (!value.medicalService) {
            return;
        }

        if (!this.clinic) {
            return;
        }

        if (!value.specialization) {
            return;
        }

        this.calculatePrice();
    }

    @Watch('patientType')
    onPatientTypeChange(newVal: string, oldVal: string) {
        if (newVal === oldVal) {
            return;
        }
        
        this.consultation.specialization = null;
        this.consultation.medicalService = null;
    }

    startInMinutes = getTimeInMinutes(this.event.start);

    price = 0;
    doctorMedicalServices: MedicalServiceTypeItem[] = [];
    doctorMedicalServicesFiltered: SelectItemType[] = [];
    doctorSpecializationsRaw: DoctorSpecialization[] = [];
    typesList = [];

    consultation: InitialCalendarConsultation = {
        duration: getMinutesDifference(this.event),
        patient: null,
        medicalService: null,
        clinic: null,
        specialization: null,
    }
    errors: CalendarConsultationErrors = {};
    patientsList: any[] = [];
    patientTypeDictionary: Record<string, string> = {};

    get emptySpecializationError() {
        if (this.consultationPatient && !this.doctorSpecializations.length) {
            return `Нет специализации для типа пациента ${this.patientType}`;
        }

        return '';
    }

    get clinicItems() {
        if (!this.clinic) {
            return [];
        }

        const anyClinic: any = this.clinic;

        if ('value' in anyClinic) {
            return [anyClinic as SelectItem];
        }

        if ('title' in anyClinic) {
            return [{
                id: anyClinic.id,
                value: anyClinic.title,
            } as SelectItem];
        }

        return [];
    }

    get doctorModel() {
        return DoctorEntityModule.doctorDetail;
    }

    get doctorTypesList() {
        return DoctorEntityModule.typesList;
    }

    get availableTypesModelList():any {
        return this.doctorModel?.availableTypes.map((item: any) => {
            return { id: item.id, value: item.pseudonym };
        });
    }

    get availableTypesList() {
        const modelList = this.availableTypesModelList.map((item: { id: number }) => { return item.id });

        const items: any = this.typesList.filter((item: { id: number }) => {
            return modelList.find((modelType: number) => { return modelType === item.id });
        });

        const isOnline = items.findIndex((item: { shortTitle: string }) => {
            return item.shortTitle.toLocaleLowerCase() === 'онлайн';
        });

        if (isOnline !== -1) {
            const onlineItem = this.typesList.find((item: { shortTitle: string }) => { return !item.shortTitle });

            items.splice(isOnline + 1, 0, onlineItem)
        }

        const result = items.map((item: { id: number; title: string }) => {
            return {
                id: item.id,
                value: item.title,
            }
        })

        return result;
    }

    get consultationPatient() {
        return this.consultation.patient;
    }

    get patientType() {
        if (!this.consultation.patient) {
            return '';
        }

        const patient = this.patientsList.find(patient => patient.id === this.consultation.patient?.id);
        return patient?.type || '';
    }

    get doctorSpecializations() {
        return this.doctorSpecializationsRaw
            .filter(spec => [this.patientType, 'Любой'].includes(spec.type.label))
            .map((spec: DoctorSpecialization) => ({ id: spec.id, value: spec.title }));
    }

    get endTime() {
        const endTime = this.startInMinutes + this.consultation.duration;

        return formatMinutesToTime(endTime);
    }

    get doctorId() {
        if (this.$route.params.doctorsId) {
            return +this.$route.params.doctorsId;
        }

        return CalendarModule.doctorId;
    }

    get entityName() {
        return !isNaN(+this.doctorId) ? `doctors/${this.doctorId}/specializations` : 'specializations';
    }

    get isShowClinics() {
        if (!this.consultation.medicalService?.id) {
            return false;
        }

        const onlineMedicalServices = this.doctorMedicalServices
            .filter(service => service.title.indexOf('онлайн') !== -1)
            .map(service => service.id);
        
        return !onlineMedicalServices.includes(this.consultation.medicalService?.id);
    }
    
    @Watch('consultation.duration')
    updateDuration(duration: number) {
        this.$emit('update:duration', duration);
    }

    validate()  {
        const errors: CalendarConsultationErrors = {};

        if (!this.consultation.medicalService) {
            errors.medicalService = 'Значение не должно быть пустым'
        }
        
        if (!this.consultation.patient) {
            errors.patient = 'Значение не должно быть пустым'
        }
        
        if (!this.clinic && this.isShowClinics) {
            errors.clinic = 'Значение не должно быть пустым'
        }

        if (!this.consultation.specialization) {
            errors.specialization = 'Значение не должно быть пустым'
        }

        this.errors = errors;
        
        const errorsCount = Object.keys(errors).length

        return errorsCount > 0;
    }

    save() {
        const hasErrors = this.validate();
        if (hasErrors) {
            ResponseHandlerModule.showNotify({ message: 'Не все поля заполнены', type: 'fail'})
            return;
        }

        const startTime = convertMinutes(this.startInMinutes);
        const start = setTimeWithinDay(this.event.start, startTime);

        const consultation = {
            ...this.consultation,
            clinic: this.clinic,
            start,
        }
        this.$emit('create', consultation);
    }

    close() {
        this.$emit('close');
    }

    async calculatePrice() {
        if (!this.doctorId) {
            return;
        }

        try {
            const price = await getConsultationCalculated(
                this.consultation.medicalService?.id as number,
                +this.doctorId,
                this.consultation.specialization?.id as number,
                this.consultation.patient?.id as number,
                this.clinic?.id as number,
            );
    
            this.price = price;
        } catch (clientError) {
            ResponseHandlerModule.cancelRedirectToNotFound();
            const error = clientError.response.data;
            const errorMessage = error.message;

            ResponseHandlerModule.showNotify({ message: errorMessage, type: 'fail' });
        }
    }

    updateSpecializationValue(spec: SelectItem) {
        this.consultation.specialization = spec;

        const rawSpec = this.doctorSpecializationsRaw.find(specRaw => spec.id === specRaw.id);
        if (rawSpec?.isCommonPractice) {
            this.doctorMedicalServicesFiltered = this.doctorMedicalServices.map(doctorMedicalServicesMapper);

            return;
        }

        this.doctorMedicalServicesFiltered = this.doctorMedicalServices
            .filter(service => (!service.isRegularConsultation))
            .map(doctorMedicalServicesMapper);

        if (!this.doctorMedicalServicesFiltered.find(service => service.id === this.consultation.medicalService?.id)) {
            this.consultation.medicalService = null;
        }
    }

    updateMedicalServiceValue(service: SelectItem) {
        this.consultation.medicalService = service;
    }

    listLoadedHandler(list: any[]) {
        this.patientsList = list;
    }

    async initDoctorInfo() {
        const promises = [
            getById('doctors', this.doctorId as string),
            getList('medical-service-types', { page: 1 })
        ];

        const [doctor, serviceTypes] = await Promise.all(promises);

        this.doctorMedicalServices = serviceTypes.table.rows;

        this.doctorSpecializationsRaw = doctor?.doctor?.specializations ? Object.values(doctor.doctor.specializations) : this.doctorSpecializationsRaw;
    }

    async initTypesList() {
        const data = await getList('medical-service-types', { page: 1 });

        this.typesList = data.table.rows;
    }

    async mounted() {
        this.initDoctorInfo();

        const dictionaries = await getDictionaries()
        this.patientTypeDictionary = dictionaries.patientTypes;

        await this.initTypesList();
    }
}
